"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var tim_1 = require("../../../../TUICore/tim");
var emojiMap_1 = require("../utils/emojiMap");
var utils_1 = require("../utils/utils");
var index_vue_1 = require("../index.vue");
exports.default = vue_1.defineComponent({
    props: {
        message: {
            type: Object,
            default: function () { return ({}); },
        },
        emojiList: {
            type: Array,
            default: function () { return []; },
        },
        type: {
            type: String,
            default: '',
        },
    },
    emits: ['handleCollapse'],
    setup: function (props, ctx) {
        var TUIServer = index_vue_1.default.TUIServer;
        var data = vue_1.reactive({
            message: {},
            emojiUrl: emojiMap_1.emojiUrl,
            emojiMap: emojiMap_1.emojiMap,
            emojiName: emojiMap_1.emojiName,
            isCollapse: true,
            types: tim_1.default.TYPES,
            env: TUIServer.TUICore.TUIEnv,
            type: props.type,
            emojiReacts: {},
            allMemberList: [],
        });
        var container = vue_1.ref({});
        var emojiCollapseList = vue_1.computed(function () {
            return data.emojiName.slice(0, 6);
        });
        var emojiExpandList = vue_1.computed(function () {
            return data.emojiName.slice(6);
        });
        var select = function (item) {
            TUIServer.emojiReact(data.message, item);
        };
        var handleEmojiReact = function (message) {
            var _a, _b;
            try {
                if (!(message === null || message === void 0 ? void 0 : message.cloudCustomData))
                    return;
                var reactList = (_b = (_a = utils_1.JSONToObject(message === null || message === void 0 ? void 0 : message.cloudCustomData)) === null || _a === void 0 ? void 0 : _a.messageReact) === null || _b === void 0 ? void 0 : _b.reacts;
                if (!reactList)
                    return;
                data.emojiReacts = reactList;
                return reactList;
            }
            catch (err) {
                console.warn(err);
            }
        };
        var handleEmojiReactItem = function (userIDList) {
            var res = '';
            userIDList === null || userIDList === void 0 ? void 0 : userIDList.forEach(function (item, index) {
                var _a, _b;
                var memberInfo = (_a = data.allMemberList) === null || _a === void 0 ? void 0 : _a.find(function (member) { return member.userID === item; });
                res = res + (memberInfo ? (_b = memberInfo) === null || _b === void 0 ? void 0 : _b.nick : item) + ', ';
            });
            if (res.length)
                res = res.substring(0, res.lastIndexOf(','));
            return res;
        };
        var handleAllMemberList = function (message) {
            var _a, _b, _c, _d, _e, _f, _g;
            var TUIChatStore = TUIServer === null || TUIServer === void 0 ? void 0 : TUIServer.currentStore;
            switch (message === null || message === void 0 ? void 0 : message.conversationType) {
                case tim_1.default.TYPES.CONV_C2C:
                    data.allMemberList = [
                        {
                            userID: (_b = (_a = TUIChatStore === null || TUIChatStore === void 0 ? void 0 : TUIChatStore.conversation) === null || _a === void 0 ? void 0 : _a.userProfile) === null || _b === void 0 ? void 0 : _b.userID,
                            nick: (_d = (_c = TUIChatStore === null || TUIChatStore === void 0 ? void 0 : TUIChatStore.conversation) === null || _c === void 0 ? void 0 : _c.userProfile) === null || _d === void 0 ? void 0 : _d.nick,
                        },
                        {
                            userID: (_e = TUIChatStore === null || TUIChatStore === void 0 ? void 0 : TUIChatStore.selfInfo) === null || _e === void 0 ? void 0 : _e.userID,
                            nick: (_f = TUIChatStore === null || TUIChatStore === void 0 ? void 0 : TUIChatStore.selfInfo) === null || _f === void 0 ? void 0 : _f.nick,
                        },
                    ];
                    break;
                case tim_1.default.TYPES.CONV_GROUP:
                    data.allMemberList = (_g = TUIChatStore === null || TUIChatStore === void 0 ? void 0 : TUIChatStore.allMemberList) === null || _g === void 0 ? void 0 : _g.memberList;
                    break;
                default:
                    break;
            }
        };
        vue_1.watch(function () { return props.message; }, function (newVal, oldVal) {
            data.message = props.message;
            if ((newVal === null || newVal === void 0 ? void 0 : newVal.conversationID) !== (oldVal === null || oldVal === void 0 ? void 0 : oldVal.conversationID)) {
                handleAllMemberList(newVal);
            }
        }, { deep: true, immediate: true });
        vue_1.watch(function () { return data.isCollapse; }, function (newVal, oldVal) {
            var _a;
            if (newVal === oldVal)
                return;
            if (!((_a = data === null || data === void 0 ? void 0 : data.env) === null || _a === void 0 ? void 0 : _a.isH5))
                return;
            ctx.emit('handleCollapse', newVal);
        });
        return __assign(__assign({}, vue_1.toRefs(data)), { emojiCollapseList: emojiCollapseList,
            emojiExpandList: emojiExpandList,
            select: select,
            handleEmojiReact: handleEmojiReact,
            handleEmojiReactItem: handleEmojiReactItem,
            container: container });
    },
});
